<div *ngIf="listingForm">
  <div dragula="site-images" class="dragula-container">
    <ng-container *ngFor="let photo of photos?.controls; let i = index">
      <div class="image-card">
        <div class="image-wrapper">
          <img [src]="getPhotoUrl(photo.value)" />
        </div>
        <div class="_1up-outer-wrapper caption">
          <div class="image-card-caption-wrapper">
            <input
              type="text"
              class="text-input caption w-input"
              id="caption-{{ i }}"
              name="caption-{{ i }}"
              readonly
              [formControl]="photo.get('caption')"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<curbnturf-image-upload [options]="uploadOptions" (save)="save($event)"> </curbnturf-image-upload>
